import { useEffect, useLayoutEffect, useRef, useState } from 'react'

import { useAppSelector } from '../../app/hooks'
import { ZoneTypeEnum } from '../../shared/types'
import mapIcon from '../../images/menu-map-icon.jpg'
import profileIcon from '../../images/menu-profile-icon.jpg'
import scriptIcon from '../../images/menu-script-icon.jpg'

const ZONE_LINKS = {
  [ZoneTypeEnum.Case]: [
    // { path: '/', label: 'Home' },
    { path: '/map', label: 'Map', image: mapIcon }, // goes to /dashboard
    { path: '/profile', label: 'Profile', image: profileIcon },
    { path: '/script', label: 'Script', image: scriptIcon },
  ],
  [ZoneTypeEnum.Brief]: [
    { path: '/', label: 'Home', image: '' },
    { path: '/profile', label: 'Profile', image: profileIcon },
  ],
}

const useNavigation = () => {
  const { data: zoneData } = useAppSelector((state) => state.zone)

  const [showMenu, setShowMenu] = useState(true)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const links = zoneData?.type
    ? ZONE_LINKS[zoneData?.type as keyof typeof ZONE_LINKS]
    : []

  // Helper to clear any existing timer
  const clearMenuTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }

  // Start a hide-menu timer
  const startMenuTimer = (delay: number = 1000) => {
    clearMenuTimer()
    timerRef.current = setTimeout(() => {
      setShowMenu(false)
      timerRef.current = null
    }, delay)
  }

  // Initial hide timer
  useEffect(() => {
    if (showMenu) startMenuTimer(1000)

    return () => clearMenuTimer() // cleanup on unmount
  }, [])

  const handleToggleMenu = () => {
    setShowMenu((prev) => !prev)
    // reset timer for auto-hide after toggle
    if (!showMenu) {
      startMenuTimer(5000) // show menu for 5s after toggle
    } else {
      clearMenuTimer() // if hiding manually, cancel auto-hide
    }
  }

  return {
    links,
    showMenu,
    handlers: {
      handleToggleMenu,
    },
  }
}

export default useNavigation
